import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Styled Components */
import { PermissionText } from '../styles/PermissionContainer';

const NoPermissions = () => {
  const { t } = useTranslation();

  return (
    <PermissionText>
      {t('settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.SPECIAL.EMPTY', { roleName: t('settings:TEACHER')})}
    </PermissionText>
  );
};

export default NoPermissions;
